export default __webpack_public_path__ + "static/media/search.210ae516.svg";